/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  fetchNotificationFormation({ commit },userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/notification_formateur/${userId}`)
        .then((response) => {
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchNotificationCandidat({ commit },userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/notification_candidat/${userId}`)
        .then((response) => {
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchUsers({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("https://trainingcenterback.codily.net/api/demande_inscrie")
        .then((response) => {
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchUser(context, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/getCandidat_id/${userId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeRecord({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.delete(`https://trainingcenterback.codily.net/api/destroyparticipation/${userId}`)
        .then((response) => {
          //commit('REMOVE_RECORD', obj.notivicationId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateRecord({ commit }, user) {
    return new Promise((resolve, reject) => {
      axios.post(`https://trainingcenterback.codily.net/api/updateCandidat/${user.id}`, user)
        .then((response) => {

          // Convert Date String to Date Object
          let user = response.data
          console.log("user",user)
          commit('UPDATE_USERS', user)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  
  
}
